export default __webpack_public_path__ + "static/media/m&p.123659fc.svg";